const extractLongestLabel = labels => {
  if (!labels.length) {
    return null
  }

  const firstLabel = labels[0]

  const group = labels.reduce(
    (accumulator, label, index) => {
      if (label.startsWith(accumulator.label)) {
        accumulator.labels.push({ index, label })
      }
      return accumulator
    },
    { labels: [], label: firstLabel }
  )

  return group.labels.reduce(
    (accumulator, item, index) => {
      labels.splice(item.index - index, 1)

      if (accumulator.label.length == item.label.length) {
        accumulator.labels.push(item.label)
      } else if (accumulator.label.length < item.label.length) {
        accumulator.labels = [item.label]
        accumulator.label = item.label
      }

      return accumulator
    },
    { labels: [], label: firstLabel }
  )
}

export default labels => {
  const copyOfLabels = labels.slice()
  let longestLabels = []
  let flag = true

  while (flag) {
    const extracted = extractLongestLabel(copyOfLabels)
    if (extracted) {
      longestLabels = longestLabels.concat(extracted.labels)
    } else {
      flag = false
    }
  }

  return longestLabels
}
